import { Link } from 'react-router-dom'
import { 
  UsersIcon,
  AcademicCapIcon,
  DocumentTextIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline'
import { UserRole } from '../../types/auth'

interface QuickActionsProps {
  userRole?: UserRole
}

const QuickActions = ({ userRole = 'aluno' }: QuickActionsProps) => {
  const getActions = () => {
    switch (userRole) {
      case 'admin':
        return [
          {
            name: 'Criar Usuário',
            href: '/users/new',
            icon: UsersIcon,
            description: 'Adicionar novo usuário ao sistema'
          },
          {
            name: 'Nova Aula',
            href: '/aulas/new',
            icon: AcademicCapIcon,
            description: 'Criar uma nova aula'
          },
          {
            name: 'Nova Questão',
            href: '/questoes/new',
            icon: DocumentTextIcon,
            description: 'Adicionar questão ao banco'
          },
          {
            name: 'Novo Teste',
            href: '/testes/new',
            icon: ChartBarIcon,
            description: 'Criar novo teste'
          }
        ]
      case 'professor':
        return [
          {
            name: 'Nova Aula',
            href: '/aulas/new',
            icon: AcademicCapIcon,
            description: 'Criar uma nova aula'
          },
          {
            name: 'Nova Questão',
            href: '/questoes/new',
            icon: DocumentTextIcon,
            description: 'Adicionar questão ao banco'
          },
          {
            name: 'Novo Teste',
            href: '/testes/new',
            icon: ChartBarIcon,
            description: 'Criar novo teste'
          }
        ]
      case 'aluno':
      default:
        return [
          {
            name: 'Ver Aulas',
            href: '/aulas',
            icon: AcademicCapIcon,
            description: 'Acessar aulas disponíveis'
          },
          {
            name: 'Fazer Teste',
            href: '/testes',
            icon: ChartBarIcon,
            description: 'Realizar testes disponíveis'
          }
        ]
    }
  }

  const actions = getActions()

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
          Ações Rápidas
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {actions.map((action) => {
            const IconComponent = action.icon
            return (
              <Link
                key={action.name}
                to={action.href}
                className="relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-500 rounded-lg border border-gray-200 hover:border-primary-300 hover:shadow-md transition-all duration-200"
              >
                <div>
                  <span className="rounded-lg inline-flex p-3 bg-primary-50 text-primary-600 group-hover:bg-primary-100">
                    <IconComponent className="h-6 w-6" aria-hidden="true" />
                  </span>
                </div>
                <div className="mt-4">
                  <h3 className="text-lg font-medium text-gray-900 group-hover:text-primary-600">
                    <span className="absolute inset-0" aria-hidden="true" />
                    {action.name}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">
                    {action.description}
                  </p>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default QuickActions